import React from 'react';
import s from './Layout.module.scss';
import logoWhite from '../../assets/logo-white.svg';
import eleiot from '../../assets/eleiot.svg';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Button from 'react-bootstrap/Button';
const Layout = ({ children }) => (


  <div className={s.mainContainer}>
    <div className={s.contactSection}>
      <span>
        <FormattedMessage id="general.needHelp" defaultMessage="Need help?" />
      </span>
      <Button variant="outline-secondary">
        <FormattedMessage id="general.contactUsNow" defaultMessage="CONTACT US NOW" />
      </Button>
    </div>
    <div className={s.mainCard}>
      <div className={s.leftPanel}>
        {children}
      </div>

      <div className={s.rightPanel}>
        <div className={classNames(s.imageSectionNoAuth, s.hideMobile, s.hideTablet)}>
          <div className={s.logoContainer}>
            <img src={logoWhite} alt="icon" /> 
         
            <p>
              <FormattedMessage
                id="layout.tagline1"
                defaultMessage="Water treatment with its own brain"
              />
            </p>
          </div>
          <div className={s.eleiotContainer}>
              <img src={eleiot} alt="icon"  className={s.eleiot}/> 
          </div>

        </div>
      </div>
    </div>
  </div>


);

export default Layout;
